import UnitsTable from "@/app/app-shared/units/table";

export interface FloorPlanUnitsPageProps {}

export default function FloorPlanUnitsPage({}: FloorPlanUnitsPageProps) {
  return <UnitsTable />;
}
